import { Skeleton } from '@gravity-ui/uikit';

import styles from '../styles.module.scss';

export const Loader = () => {
	return (
		<div className={styles.container}>
			<div className={styles.help__list}>
				<Skeleton style={{ width: '265px', height: '60px' }} />
			</div>
			<div className={styles.info}>
				<Skeleton className={styles.info__title} style={{ width: '360px', height: '24px' }} />
				<div className={styles.info__block}>
					<Skeleton className={styles.info__title} style={{ width: '156px', height: '20px' }} />
					<div className={styles.info__row}>
						<Skeleton style={{ width: '186px', height: '44px' }} />
						<Skeleton style={{ width: '537px', height: '44px' }} />
					</div>
					<div className={styles.info__row}>
						<Skeleton style={{ width: '186px', height: '44px' }} />
						<Skeleton style={{ width: '537px', height: '44px' }} />
					</div>
					<div className={styles.info__row}>
						<Skeleton style={{ width: '186px', height: '44px' }} />
						<Skeleton style={{ width: '537px', height: '86px' }} />
					</div>
					<div className={styles.info__row}>
						<Skeleton style={{ width: '186px', height: '44px' }} />
						<Skeleton style={{ width: '100px', height: '44px' }} />
					</div>
				</div>
				<div style={{ paddingTop: '12px' }}>
					<Skeleton style={{ width: '260px', height: '44px' }} />
				</div>

				<div className={styles.info__btn_group}>
					<Skeleton style={{ width: '232px', height: '44px' }} />
					<Skeleton style={{ width: '285px', height: '44px' }} />
				</div>
			</div>
		</div>
	);
};
